













































import { EnterpriceBankData as IntefaceEnterpriceBankData } from '@/store/interfaces/company';
import resourceTypes from '@/store/types/resources';
import Vue, { PropType } from 'vue';
import { mapGetters, mapActions } from 'vuex';
import { BLOCKCHAIN } from '@/const/blockchain';
import { extend } from 'vee-validate';
import { validateAddress } from '@/util/blockchainValidation';
import i18n from '@/i18n';

// Register custom validation rule for Ethereum addresses
extend('ethereumAddress', {
  validate: (value: string) => {
    return validateAddress(value, BLOCKCHAIN.ETHEREUM.code);
  },
  message: () =>
    String(i18n.t('company.bankData.blockchain.ethereumInvalidAddress')),
});

// Register custom validation rule for Tron addresses
extend('tronAddress', {
  validate: (value: string) => {
    return validateAddress(value, BLOCKCHAIN.TRON.code);
  },
  message: () =>
    String(i18n.t('company.bankData.blockchain.tronInvalidAddress')),
});

export default Vue.extend({
  name: 'UsdtBankForm',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      required: true,
      type: Object as PropType<IntefaceEnterpriceBankData>,
    },
  },
  computed: {
    ...mapGetters({
      blockchains: `resourcesModule/${resourceTypes.getters.GET_BLOCKCHAINS}`,
    }),
    bankData: {
      get(): IntefaceEnterpriceBankData {
        return this.value;
      },
      set(value: IntefaceEnterpriceBankData): void {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    ...mapActions({
      fetchBlockchains: `resourcesModule/${resourceTypes.actions.BLOCKCHAINS}`,
    }),
    getWalletAddressRules(): string {
      const baseRules = 'required|max:255';
      if (this.bankData.blockchain === BLOCKCHAIN.ETHEREUM.name) {
        return `${baseRules}|ethereumAddress`;
      } else if (this.bankData.blockchain === BLOCKCHAIN.TRON.name) {
        return `${baseRules}|tronAddress`;
      }
      return baseRules;
    },
    getConfirmWalletAddressRules(): string {
      const baseRules = `required|confirmed:${this.$t(
        'company.bankData.walletAddress.informal'
      )}|max:255`;
      if (this.bankData.blockchain === BLOCKCHAIN.ETHEREUM.name) {
        return `${baseRules}|ethereumAddress`;
      } else if (this.bankData.blockchain === BLOCKCHAIN.TRON.name) {
        return `${baseRules}|tronAddress`;
      }
      return baseRules;
    },
  },
  async mounted(): Promise<void> {
    await this.fetchBlockchains();
  },
});
